<template>
  <Layout tituloPagina="Sistema | Cuenta | Cambiar de plan Hotspot | Actualización del plan Hotspot">
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Selección de plan</h4>
          </div>
          <div class="card-body" style="min-height: 475px;">
            <div class="table-responsive">
              <table class="tblRouters table table-hover align-middle">
                <thead>
                  <tr>
                    <th><span class="h3">Caracteristicas</span></th>
                    <th v-show="estado_modulo">
                      <span class="h3">Plan {{plan_hotspot_contratado.nombre}}</span>
                      <br>
                      <big class="text-success">
                        Plan actual
                      </big>
                    </th>
                    <th>
                      <span class="h3">Plan {{plan_hotspot_seleccionado.nombre}}</span><br>
                      <big class="text-info">
                        Nuevo plan seleccionado
                      </big>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Descripción</td>
                    <td style="min-width: 300px;" v-show="estado_modulo">{{plan_hotspot_contratado.descripcion}}</td>
                    <td style="min-width: 300px;">{{plan_hotspot_seleccionado.descripcion}}</td>
                  </tr>
                  <tr>
                    <td>Notificación de routers de administración caídos</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.notificacion_routers_caidos ? "SI": "NO"}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.notificacion_routers_caidos ? "SI": "NO"}}
                    </td>
                  </tr>
                  <tr>
                    <td>Gestión de routers para hotspots</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.max_routers != -1 ? 'hasta '+plan_hotspot_contratado.max_routers : 'Ilimitado'}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.max_routers != -1 ? 'hasta '+plan_hotspot_seleccionado.max_routers : 'Ilimitado'}}
                    </td>
                  </tr>
                  <tr>
                    <td>Diseño de portal cautivo</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.layout_portal_cautivo ? "SI": "NO"}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.layout_portal_cautivo ? "SI": "NO"}}
                    </td>
                  </tr>
                  <tr>
                    <td>Hotspot</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.max_hotspots != -1 ? 'hasta '+plan_hotspot_contratado.max_hotspots : 'Ilimitado'}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.max_hotspots != -1 ? 'hasta '+plan_hotspot_seleccionado.max_hotspots : 'Ilimitado'}}
                    </td>
                  </tr>
                  <tr>
                    <td>Fichas</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.max_fichas != -1 ? 'hasta '+plan_hotspot_contratado.max_fichas : 'Ilimitado'}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.max_fichas != -1 ? 'hasta '+plan_hotspot_seleccionado.max_fichas : 'Ilimitado'}}
                    </td>
                  </tr>
                  <tr>
                    <td>Impresión de fichas</td>
                    <td v-show="estado_modulo">SI</td>
                    <td>SI</td>
                  </tr>
                  <tr>
                    <td>Diseño de fichas</td>
                    <td v-show="estado_modulo">
                      {{plan_hotspot_contratado.layout_fichas ? "SI": "NO"}}
                    </td>
                    <td>
                      {{plan_hotspot_seleccionado.layout_fichas ? "SI": "NO"}}
                    </td>
                  </tr>
                  <tr>
                    <td>Generación de fichas desde cualquier lugar</td>
                    <td v-show="estado_modulo">SI</td>
                    <td>SI</td>
                  </tr>
                  <tr>
                    <td>Eliminación de fichas vencidas en los routers.</td>
                    <td v-show="estado_modulo">SI</td>
                    <td>SI</td>
                  </tr>
                  <tr>
                    <td>Precio mensual</td>
                    <td v-show="estado_modulo">
                      ${{plan_hotspot_contratado.precio_mensual}} USD
                    </td>
                    <td>
                      ${{plan_hotspot_seleccionado.precio_mensual}} USD
                    </td>
                  </tr>
                  <tr>
                    <td>Precio anual</td>
                    <td v-show="estado_modulo">
                      ${{plan_hotspot_contratado.precio_anual}} USD <br>
                      <strong>{{costoAnualPocentaje(plan_hotspot_contratado.precio_mensual, plan_hotspot_contratado.precio_anual)}}</strong>
                    </td>
                    <td>
                      ${{plan_hotspot_seleccionado.precio_anual}} USD <br>
                      <strong>{{costoAnualPocentaje(plan_hotspot_seleccionado.precio_mensual, plan_hotspot_seleccionado.precio_anual)}}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="text-right pb-4">
          <div class="btn-group">
            <button class="btn btn-secondary"
              @click="$router.go(-1)">
              <i class="mdi mdi-chevron-left"></i>
              Atras
            </button>

            <button class="btn btn-success" @click="actualizarModuloPlan()">
              <i class="mdi mdi-refresh"></i>
              {{estado_modulo ? 'Cambiar' : 'Activar'}} plan Hotspot
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <w-saldo></w-saldo>
      </div>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import WSaldo from '@/views/sistema/cuenta/WSaldo.vue'
import CuentaSrv from '@/services/CuentaSrv.js'
export default {
  name: 'Adm3ArgusblackActualizarPlanHotspot',
  components: { Layout, WSaldo },
  data() {
    return {
      id_plan_seleccionado: null,

      estado_modulo: false,

      plan_hotspot_contratado: {
        id: null,
        descripcion: "",
        layout_fichas: 0,
        layout_portal_cautivo: 0, 
        max_fichas: 0,
        max_hotspots: 0,
        max_routers: 0,
        nombre: "", 
        notificacion_routers_caidos: 0, 
        precio_anual: 0,
        precio_mensual: 0
      },

      plan_hotspot_seleccionado: {
        id: null,
        descripcion: "",
        layout_fichas: 0,
        layout_portal_cautivo: 0, 
        max_fichas: 0,
        max_hotspots: 0,
        max_routers: 0,
        nombre: "", 
        notificacion_routers_caidos: 0, 
        precio_anual: 0,
        precio_mensual: 0
      }
    }
  },

  created: function () {
    var self = this

    self.id_plan_seleccionado = self.$route.params.id_plan

    self.cargarEstado(function() {
      self.cargarPlanSeleccionado()
    })
  },
  methods: {
    actualizarModuloPlan:function() {
      var self = this 
      let datos = {
        id_plan: self.plan_hotspot_seleccionado.id
      }

      if(self.plan_hotspot_contratado.id != null) Object.assign(datos, {id_plan_actual: self.plan_hotspot_contratado.id})

      CuentaSrv.actualizarModuloPlanContratado('hotspot', datos).then(response => {
        let mensaje = self.estado_modulo ? 'Se cambio correctamente el plan seleccionado' : 'Se activo correctamente el plan seleccionado'
        iu.msg.success(mensaje)

        self.$router.push({ name: 'sistemaCuenta'})
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo activar o cambiar plan'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarEstado: function(callback) {
      var self = this

      CuentaSrv.estadoModulo('hotspot').then(response => {
        self.estado_modulo = response.data

        if(self.estado_modulo == true) self.cargarPlanContratado()

        if(callback) callback()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPlanContratado: function (){
      var self = this

      CuentaSrv.moduloPlanContratadoJSON('hotspot').then(response => {
        self.plan_hotspot_contratado = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarPlanSeleccionado:function () {
      var self = this

      CuentaSrv.moduloPlanJSON('hotspot', self.id_plan_seleccionado).then(response => {
        self.plan_hotspot_seleccionado = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar cuenta'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    costoAnualPocentaje: function(precio_mensual, precio_anual){
      if(precio_anual < 0) return ''

      let total = precio_mensual * 12
      let porcentaje = ((total - precio_anual) * 100) / total

      if(porcentaje < 0) return ''

      return `Costo anual (incluye ${parseInt(porcentaje)}% de descuento)`
    }
  }
}
</script>

<style scoped>

</style>